module.exports = __webpack_public_path__ + "img/Pegelrechnung1.dd510dec.jpg";